import { type FunctionComponent, useEffect, useRef } from 'react';

import { FrameGrabber } from '../../../stream/ambientLight/FrameGrabber';
import type { VideoMirrorProps } from '../VideoMirror';

import { CanvasMirrorRenderer } from './CanvasMirrorRenderer';

const WIDTH = 384;
const HEIGHT = 216;

const MirrorFrameGrabber = new FrameGrabber({ width: WIDTH, height: HEIGHT });
MirrorFrameGrabber.setVideoEnabled(true);

export const CanvasMirror: FunctionComponent<VideoMirrorProps> = ({ videoElement }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!videoElement || !canvasRef.current) return;

    MirrorFrameGrabber.init(videoElement);

    const renderer = new CanvasMirrorRenderer(MirrorFrameGrabber, canvasRef.current, videoElement);
    renderer.start();

    return (): void => {
      renderer.destroy();
    };
  }, [videoElement]);

  return <canvas width={WIDTH} height={HEIGHT} ref={canvasRef} />;
};
